import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.768 11.333H20.666V.243c2.013.205 3.8.54 5.025 1.02 4.447 1.728 5.476 6.646 5.476 6.646.274 1.138.469 2.289.6 3.424",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M11.333.242v11.091H.252c.139-1.14.34-2.302.614-3.458 0 0 1.03-4.918 5.476-6.646C7.547.77 9.325.443 11.333.242m20.415 20.425a31 31 0 0 1-.615 3.457s-1.028 4.918-5.476 6.646c-1.204.479-2.982.803-4.99.998V20.667z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.238 20.667h11.095v11.091c-2.008-.201-3.786-.528-4.99-.988C1.894 29.042.865 24.124.865 24.124a28 28 0 0 1-.628-3.457",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M12.889 12.522a4.667 4.667 0 1 0 6.223 0 .667.667 0 1 0-.89.993 3.333 3.333 0 1 1-4.444 0 .667.667 0 1 0-.89-.993"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "M12.475 11.082c-.28.174-.346.232-.192.512-.036.025-.292.103-.355.125-.233.088-.47.177-.668.296-.12.073-.171.127-.264.223l.582-.045c-.018.038-.06.092-.084.128-.1.144-.162.258-.248.408.164-.111.313-.216.503-.309.416-.21 1.165-.215 1.472-.584.078-.093.03-.149-.035-.3.227-.076.312-.129.589-.191.667-.149 1.127.028 1.45-.052.1-.025.198-.08.205-.186l-.047-.337 1.083-.001c.002.19-.182.435.154.523.305.08.92-.095 1.451.053l.59.19c-.004.028-.046.103-.058.142-.026.069-.023.105.02.153.058.066.14.131.226.181.173.099.398.162.612.213.612.149.67.188 1.14.502-.03-.092-.255-.419-.329-.534l.58.046c-.1-.152-.406-.312-.582-.381l-.706-.258c.064-.123.118-.225.054-.327-.098-.148-.687-.438-.836-.478a8 8 0 0 0-.772-.166 12 12 0 0 0-.734-.075c-.034-.036.067-.228-.088-.362-.091-.072-.223-.097-.357-.11-.539-.052-1.272-.037-1.816 0-.157.009-.268.026-.357.11-.11.103-.124.166-.114.36-.726-.013-1.46.152-2.069.53"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M13.567 19.077a3.5 3.5 0 0 0-.767.328c-.107-.16-.253-.398-.356-.537a.8.8 0 0 0-.24-.205c-.159-.074-.217-.051-.317.035l-.071-.134c-.143-.25-.292-.366-.45-.569l-.143-.167c-.02-.022-.026-.038-.052-.051.062.201.106.394.146.613-.087-.048-.168-.096-.259-.135a1 1 0 0 0-.327-.054l.104.093c.178.157.294.366.365.6.078.254.26.524.45.71a.9.9 0 0 0 .22.163c.214.078.205-.003.282-.041.165.278.27.418.46.629.204.215.525.273.816.205.13-.032.21-.067.31-.125.38-.218.198-.388.153-.562.123-.038.605-.184.778-.216.61-.113 1.74-.128 2.464-.022.065.009.794.203.865.245a.6.6 0 0 0-.064.313c.012.123.118.188.211.242a1.1 1.1 0 0 0 .703.141c.272-.044.415-.202.531-.343.194-.221.254-.355.353-.51 0 0 .055.05.095.064a.5.5 0 0 0 .19-.023c.094-.035.152-.106.217-.167.2-.192.37-.443.45-.716.097-.32.23-.471.466-.68-.305.01-.41.093-.583.19l.065-.315c.02-.087.068-.216.078-.299-.139.148-.262.303-.385.44-.059.077-.123.141-.182.225-.122.189-.099.194-.145.256-.43-.238-.623.343-.914.7-.538-.303-1.007-.398-1.641-.513-.142-.015-.269-.036-.385-.049a9.6 9.6 0 0 0-2.468.03c-.41.051-.662.126-1.023.211"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M13.621 13.005c.006.041.003 3.45.003 3.802 0 .337.004.55.164.764.132.185.354.337.57.388.153.03.715.018.911.018.435-.02.487.077.651.292.187-.302.393-.307.777-.292.196 0 .615.016.79-.021a.88.88 0 0 0 .504-.316c.22-.253.208-.568.208-.899V13.15c0-.163-.019-.122.064-.206l.541-.568-5.782.003z"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#227FBB", d: "M15.427 14.697v-2.322h-2.392l.594.627.005 1.695z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M16.385 14.697v-2.322h2.437l-.622.666v1.656zm-.958.959h-1.81l-.005 1.463c.082.64.554.857.978.855.287.003.385-.002.837-.005z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "M16.385 15.656h1.821L18.2 17.12c-.043.634-.554.857-.978.855l-.837-.005z"
    }
  )
);
var SvgFlagDom = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagDom_default = SvgFlagDom;

export { FlagDom_default as default };
